import * as styles from './FlexSpacer.css';

export const FlexSpacer = () => <div className={styles.base} />;
